define('glu/grid/column/columnHeader',['require','../../layout','hbs!./columnHeader.hbs','hbs!./columnHeaderRowSelector.hbs','./columnHeaderResizer','./columnHeaderDragger','./../filter/dateRangeSearch','./../filter/textSearch','./../filter/enumSearch','./../filter/numericSearch','./../filter/amountSearch','./../filter/numberRangeSearch','../filter/multiSelectSearch','../../util'],function(require) {

    'use strict';

    var Layout = require('../../layout'),
        tpl = require('hbs!./columnHeader.hbs'),
        rowSelectorTpl = require('hbs!./columnHeaderRowSelector.hbs'),
        ColumnHeaderResizer = require('./columnHeaderResizer'),
        ColumnHeaderDragger = require('./columnHeaderDragger'),
        DateRangeSearch = require('./../filter/dateRangeSearch'),
        TextSearch = require('./../filter/textSearch'),
        EnumSearch = require('./../filter/enumSearch'),
        NumericSearch = require('./../filter/numericSearch'),
        AmountSearch = require('./../filter/amountSearch'),
        NumberRangeSearch = require('./../filter/numberRangeSearch'),
        MultiSelectSearch = require('../filter/multiSelectSearch'),
        util = require('../../util');

    return Layout.extend({
        template: tpl,
        tagName: 'th',

        modelEvents: {
            'change:width': 'setWidth'
        },

        events: {
            'click @ui.toggleMenuButton': 'handleToggleMenu',
            'mousedown': 'handleMouseDown',
            'touchstart': 'handleMouseDown',
            'click @ui.allRowsSelectorCheckbox': 'handleSelectAllRows'
        },

        triggers: {
            'click .txt': 'click'
        },

        ui: {
            buttons: 'button',
            gridHeaderContent: '.grid-header-content',
            allRowsSelectorCheckbox: '.grid-all-rows-selector'
        },

        initialize: function(options) {
            this.defaultWidth = options.defaultWidth || 'auto';
            this.gridCid = options.gridCid;
            this.masterCollection = options.masterCollection;

            if (!this.model.has('label')) {
                this.model.set('label', this.model.get('title'), {
                    silent: true
                });
            }

            this.filterProcessor = options.filterProcessor;
        },

        delegateEvents: function() {
            Layout.prototype.delegateEvents.apply(this, arguments);

            this.initializeEventListeners();

            var field = this.model.get('field');

            if (field && this.masterCollection) {

                this.listenTo(this.masterCollection, 'grid:removeFilter:' + field, function(value) {
                    this.removeFilter(value, field);
                });

                this.listenTo(this.masterCollection, 'grid:filter:' + field, this.filterBy, this);
                this.listenTo(this.masterCollection, 'grid:filter:change', this.uncheckColumnSelect, this);

                if (this.model.has('selectAllCondition')) {
                    this.listenTo(this.masterCollection, 'sync add remove reset', this.updateAllCheckboxState, this);
                }
            }
        },

        onClose: function() {
            if (this.columnResizeManager) {
                this.columnResizeManager.close();
            }

            if (this.columnOrderManager) {
                this.columnOrderManager.close();
            }

            if (this.filterView) {
                this.filterView.close();
            }

        },

        // Conditionally change the template based on the column type
        // TODO: ideally we should introduce tableHeader subclasses.
        getTemplate: function() {
            return this.model.get('type') === 'rowSelector' ? rowSelectorTpl : tpl;
        },

        onBeforeRender: function() {
            this.setColumnOptions('sortable');
            this.setColumnOptions('resizable');
            this.setColumnOptions('draggable');
        },

        render: function() {
            Layout.prototype.render.call(this);

            if (this.model.has('sort')) {
                this.el.setAttribute('aria-sort', this.model.get('sorted') + 'ending');
            }

            if (this.model.has('className')) {
                this.$el.addClass(this.model.get('className'));
            }

            this.$el.attr('scope', (this.model.has('scope') ? this.model.get('scope') : 'col'));
            this.$el.attr('title', (this.model.get('title') || 'Column header'));

            if (this.model.has('rowButtons') || this.model.get('type') === 'rowSelector' || this.model.get('type') === 'singleRowSelector') {
                this.$el.addClass('grid-action');
            }

            if (this.model.has('rowButtons')) {
                return;
            }

            this.enableResizing();
            this.enableColumnReorder();

            return this;
        },

        onRender: function() {
            this.$el.attr('data-cid', this.model.cid);
            if (this.model.has('selectAllCondition')) {
                this.updateAllCheckboxState();
            }
            this.setWidth();
        },

        templateHelpers: function() {
            var isSortable = this.options.sortable,
                isDraggable = this.options.draggable;

            // Sortable class is also driven by `sortable` being false on a column
            isSortable = (isSortable && this.model.has('sortable')) ? this.model.get('sortable') : isSortable;

            // Draggable class is also driven by `draggable` being false on a column
            isDraggable = (isDraggable && this.model.has('draggable')) ? this.model.get('draggable') : isDraggable;

            return {
                id: this.cid,
                isSortable: isSortable,
                isDraggable: isDraggable
            };
        },

        updateAllCheckboxState: function() {
            var selected = this.model.get('selectAllCondition')();

            this.ui.allRowsSelectorCheckbox.prop('checked', selected);
        },

        removeFilter: function(value, field) {
            var filterProc = this.filterProcessor,
                filters = filterProc.filters.where({
                    field: field,
                    value: value
                });

            if (util.isNullOrUndefined(value) || (filters && filters.length === 1)) {
                filterProc.removeFilters(field);
            }
        },

        filterBy: function(value) {
            this.getFilterView().filterBy(this.model.get('field'), value);
        },

        handleFilter: function(filter) {
            if (this.filterProcessor) {
                this.filterProcessor.addFilter(filter);
            }
        },

        initializeEventListeners: function() {
            var selectedGrid,
                allRowsSelected = false;

            if (this.model.get('type') === 'rowSelector') {
                var allRowsSelectorClass = '.grid-all-rows-selector',
                    rowSelectorClass = '.column-row-selector';

                /**
                 * Listen to row selection events.
                 * The individual checkboxes are far enough away in the object graph to warrant the use of the
                 * appBus to broadcast selection events.  This also has the added benefit of only impacting the
                 * tableHeader and checkboxCell modules.
                 *
                 * We are also purposely not modifying the underlying collection.  This implementation is designed
                 * to only effect those items that are currently visible on that page.
                 */
                this.listenTo(this.appBus, 'grid:selectRow', function() {
                    selectedGrid = arguments[0].gridCid;

                    if (this.gridCid === selectedGrid) {
                        // need to provide callback to manually maintain state of the "select all" checkbox
                        if (this.model.has('selectAllCondition')) {
                            return this.$(allRowsSelectorClass).prop('checked', this.model.get('selectAllCondition')());
                        }

                        // If we have rows in the table, see how many rows are selected in the table
                        allRowsSelected = this.$el.parents('table').find(rowSelectorClass + ':not(:checked)').size() === 0;


                        // If all rows are selected, check the "select all" box.
                        this.$(allRowsSelectorClass).prop('checked', allRowsSelected);
                    }
                });

                /*
                 * Listen to pagination events.
                 * Clear the "select all" checkbox whenever a paging event is received.
                 * No need to clear the individual row selectors.  We get this for free.
                 */
                this.listenTo(this.appBus, 'grid:paginate', function() {
                    this.$el.find(allRowsSelectorClass).prop('checked', false);
                });

                /*
                 * Listen to filter events.
                 * Clear checkbox whenever a filter event is received.
                 */
                this.listenTo(this.appBus, 'grid:filter', function() {
                    this.$el.find(allRowsSelectorClass).prop('checked', false);
                    this.$el.parents('table').find(rowSelectorClass).prop('checked', false);
                });
            }
        },

        enableResizing: function() {
            // column's options should have highest priority and shouldn't be overridden due to cases
            // when we need to disable this functionality for specific columns such as action buttons
            if (!this.model.get('resizable') || !this.options.resizable) {
                return;
            }

            this.columnResizeManager = new ColumnHeaderResizer({
                data: this.model,
                grid: this.options.grid,
                th: this.el
            });

            this.columnResizeManager.render();
            this.ui.gridHeaderContent.append(this.columnResizeManager.el);
        },

        enableColumnReorder: function() {
            // column's options should have highest priority and shouldn't be overridden due to cases
            // when we need to disable this functionality for specific columns such as action buttons
            if (!this.model.get('draggable') || !this.options.draggable) {
                return;
            }

            this.columnOrderManager = new ColumnHeaderDragger({
                data: this.model,
                $th: this.$el
            });

            this.listenTo(this.columnOrderManager, 'reorder', this.handleReorder);

            this.columnOrderManager.render();
            this.ui.gridHeaderContent.prepend(this.columnOrderManager.el);
        },

        setColumnOptions: function(optionName) {
            // this mapper will be used to support legacy option
            var mapper = {
                draggable: 'reordering',
                resizable: 'resizing',
                sortable: 'sorting'
            };

            var options = {
                silent: true
            };

            if (util.isUndefined(this.model.get(optionName))) {
                this.model.set(optionName, true, options);
            }

            // Support legacy option
            if (this.model.has(mapper[optionName])) {
                this.model.set(optionName, this.model.get(mapper[optionName]), options);
            }
        },

        setWidth: function() {
            var useModelWidth = (this.model.has('width') && this.model.get('width') !== 'auto'),
                finalWidth,
                gridColumnWidth;

            if (useModelWidth) {
                finalWidth = this.model.get('width');
            } else if (this.options.disableDynamicColumnWidths) {
                finalWidth = 'auto';
            } else {
                finalWidth = this.defaultWidth;
            }

            this.$el.css({
                width: finalWidth,
                minWidth: finalWidth,
                maxWidth: finalWidth
            });

            gridColumnWidth = useModelWidth ? 'set' : 'default';

            this.$el.data({
                initialWidth: finalWidth,
                gridColumnWidth: gridColumnWidth
            });

            // When the table is finally rendered, it may be smaller than the document. If it is, then
            // any columns that were given a default width, instead instead be sized by the browser.
            // We add an attribute so that we can grab those columns as required in `tableLayout.js`.
            this.$el.attr('data-grid-column-width', gridColumnWidth);
        },

        // Broadcast the row selection event.
        handleSelectAllRows: function(e) {
            e.stopPropagation();
            // TODO Replace this with an internal/private bus for the grid
            this.appBus.trigger('grid:internal:selectAllRows:' + this.gridCid, this);
            return e;
        },

        handleReorder: function() {
            this.trigger('reorder', this);
        },

        getFilterView: function() {
            var filterView;
            switch (this.model.get('type')) {
                case 'date':
                    filterView = new DateRangeSearch({
                        model: this.model,
                        dateFormat: this.model.get('dateFormat')
                    });
                    break;
                case 'enum':
                    filterView = new EnumSearch({
                        model: this.model
                    });
                    break;
                case 'number':
                    filterView = new NumericSearch({
                        model: this.model
                    });
                    break;
                case 'numberRange':
                    filterView = new NumberRangeSearch({
                        model: this.model
                    });
                    break;
                case 'amount':
                    filterView = new AmountSearch({
                        model: this.model
                    });
                    break;
                case 'multiselect':
                    filterView = new MultiSelectSearch({
                        model: this.model,
                        grid: this.options.grid
                    });
                    break;
                case 'string':
                default:
                    filterView = new TextSearch({
                        model: this.model
                    });
                    break;
            }

            this.listenTo(filterView, 'filter', this.handleFilter);

            return filterView;
        },

        handleMouseDown: function(e) {
            if (!this.columnOrderManager) {
                return;
            }

            this.columnOrderManager.handleDragStart(e);
        },

        uncheckColumnSelect: function() {
            var isRowSelector = this.model.get('type') === 'rowSelector';

            if (!isRowSelector) {
                return;
            }

            this.ui.allRowsSelectorCheckbox.prop('checked', false);
        }
    });
});

